import React from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";

import { t } from "@auto/services";
import { OperatorUserDetailsWidget, readOperatorUser } from "@auto/users/__OperatorUserDetailsWidget";
import { operatorRoleLabelKey, operatorScopeLabelKey, operatorTerritory } from "./operatorTerritory";
import { PublicKeyQr } from "./OperatorAccountRequestDetails";

const OperatorAccountDetails = ({ gui, id }) => {
  const [scope, setScope] = React.useState(null);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    let active = true;
    const load = async () => {
      const account = await readOperatorUser(id);
      if (!account) throw new Error(t("operator.account.notFound"));
      return account;
    };
    load().then((value) => {
      if (active) {
        setScope(operatorTerritory(value));
      }
    })
      .catch((err) => { if (active) setError(err?.message || String(err)); });
    return () => { active = false; };
  }, [id]);

  return <>
    {scope ? <Box sx={{ maxWidth: 1560, mx: "auto", px: 2, pt: 2, pb: 1 }}>
      <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1.5 }}>
        <Box component="strong">{t("operator.type")}</Box>
        <Chip size="small" variant="outlined" label={t(operatorRoleLabelKey(scope.role))} />
        <Box>{scope.valid
          ? `${t(operatorScopeLabelKey(scope.role))}: ${scope.territoryLabel}`
          : t("operator.scope.unassigned")}</Box>
      </Box>
    </Box> : null}
    {error ? <Box role="alert" sx={{ maxWidth: 1560, mx: "auto", p: 2 }}>
      <Alert severity="error">{error}</Alert>
    </Box> : null}
    <OperatorUserDetailsWidget
      gui={gui}
      id={id}
      renderPublicKey={(value) => <PublicKeyQr value={value} />}
    />
  </>;
};

export const displayOperatorUser = (gui, id) => ({
  uuid: `operator-user-${id}`,
  view: () => <OperatorAccountDetails gui={gui} id={id} />
});

export default displayOperatorUser;
